<template>
  <div class="relative fs18 bg_fff center"
       :class="[
       border?'bb':'',
       titleStyle? titleStyle:'',
       fixed?'v-header-fixed':'v-header'
       ]">
    <slot name="back">
      <font class="back l0 t0 b0 absolute center"
            :class="[arrowsStyle? arrowsStyle: 'color_666']"
            @click="handle">&#xe61d;</font>
    </slot>
    <div class="absolute r30 t0 b0"
         v-if="$slots.right">
      <slot name="right"></slot>
    </div>
    <p class="ellipsis ml90 mr90">
      <slot></slot>
    </p>
  </div>
</template>

<script>
import { getENV } from 'Lib/utils'
export default {
  name: 'v-header',
  props: {
    url: String,
    isUrl: false,
    replaceUrl: '',
    backNum: {
      type: Number,
      default: -1
    },
    arrowsStyle: '',
    titleStyle: '',
    border: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: true
    },
    goBack: Function
  },
  methods: {
    async handle () {
      if (this.goBack) {
        return this.goBack()
      }
      let { source } = this.$route.query
      if (['share', 'push'].includes(source)) {
        let { code, obj, msg } = await this.$http(
          'smarthos.wechat.jsapiticket.get',
          {
            appid: getENV().appid,
            reqUrl: window.location.href
          }
        )
        if (code === '0') {
          wx.config(obj)
          // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
          wx.ready(function () {
            // 关闭网页
            wx.closeWindow()
          })
        }
      } else {
        if (this.isUrl) {
          console.log('====================================')
          console.log(this.url)
          console.log('====================================')
          this.$router.push({
            path: this.url,
            query: this.$route.query
          })
        } else if (this.replaceUrl) {
          this.$router.replace({
            path: this.replaceUrl,
            query: this.$route.query
          })
        } else {
          this.$router.go(
            this.backNum, {
            query: this.$route.query
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/public";
$h: 90px;

.v-header-fixed {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  @include h_lh($h);
}
.v-header {
  @include h_lh($h);
}
.back {
  width: $h;
}
.right {
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/v-header.vue